// extracted by mini-css-extract-plugin
export default {"radio":"radio__ShU9V","usdtLabel":"usdtLabel__svX4W"};